module.exports = __webpack_public_path__ + "img/greenland.719f9e34.svg";